import { render } from "./MFITTCouponNotification.vue?vue&type=template&id=c00f2f3e"
import script from "./MFITTCouponNotification.vue?vue&type=script&lang=js"
export * from "./MFITTCouponNotification.vue?vue&type=script&lang=js"

import "./MFITTCouponNotification.vue?vue&type=style&index=0&id=c00f2f3e&lang=scss"
script.render = render

export default script